import { clone } from "lodash";
import { combineReducers } from "redux";
import {
  RECEIVE_SERVER_ERRORS,
  RECEIVE_VALIDATION_ERRORS,
  RESET_SERVER_ERRORS,
  RESET_VALIDATION_ERRORS,
  RESET_EMAIL_PASSWORD_ERRORS,
} from "./errorActions";
import { RECEIVE_CURRENT_SESSION } from "../../Entry/session_actions";
import { DISMISS_SERVER_MESSAGE } from "../../Shared/ServerMessages/ServerMessageActions";

const serverErrors = (state = [], payload = {}) => {
  const { type, xhr, message } = payload;
  const newState = clone(state);
  let i;
  switch (type) {
    case RECEIVE_SERVER_ERRORS:
      return xhr.responseJSON || [xhr.statusText];
    case DISMISS_SERVER_MESSAGE:
      i = newState.indexOf(message);
      if (i !== -1) newState.splice(i, 1);
      return newState;
    case RECEIVE_VALIDATION_ERRORS:
    case RECEIVE_CURRENT_SESSION:
    case RESET_SERVER_ERRORS:
      return [];
    default:
      return state;
  }
};

const validationErrors = (state = {}, payload = {}) => {
  const { type, errors } = payload;
  switch (type) {
    case RECEIVE_VALIDATION_ERRORS:
      return errors;
    case RECEIVE_SERVER_ERRORS:
    case RESET_VALIDATION_ERRORS:
      return {};
    case RESET_EMAIL_PASSWORD_ERRORS:
      return {};
    default:
      return state;
  }
};

export default combineReducers({ serverErrors, validationErrors });
